/*
 * Página de busca avançada: gambits próprios e o link "Busca avançada →" no
 * modal de busca do core. A rota em si é registrada em ../extend.ts.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import { t } from '../../../utils/settings';
import installGambits from '../gambits';
import { searchPageEnabled, searchUrl } from './route';
export default function installSearchPage() {
  installGambits();

  // O SearchModal é carregado sob demanda (chunk); o extend por caminho só
  // é aplicado quando o módulo chega.
  extend('flarum/common/components/SearchModal', 'activeTabItems', function (items) {
    if (!searchPageEnabled()) return;

    // O modal também serve o admin; a página só existe no fórum.
    if (!app.route || !('canela.search' in app.routes)) return;
    const source = this.activeSource?.();
    const query = String(this.query?.() || '');
    const type = source?.resource === 'posts' ? 'posts' : source?.resource === 'users' ? 'users' : undefined;
    items.add('canelaAdvancedSearch', m("div", {
      className: "SearchModal-section CanelaSearchModal-advanced"
    }, m("hr", {
      className: "Modal-divider"
    }), m("ul", {
      className: "Dropdown-menu SearchModal-fullPage"
    }, m("li", null, m(LinkButton, {
      icon: "fas fa-sliders",
      href: searchUrl(query.trim(), type)
    }, t('extras.search.modal_link'))))),
    // Logo abaixo do "pesquisar todas as discussões" do core (80).
    75);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/extras/search', installSearchPage);